import { useState, useEffect } from 'react';
import { HYREAD_BASE_URL } from '../Constant/constant.js';

const useHyreadPreview = () => {
  const [previewBooks, setPreviewBooks] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchHyread = async () => {
      setLoading(true);
      setError(null);

      try {
        // 創建一個 12 秒的 timeout Promise
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => {
            reject(new Error('Request timeout after 12 seconds'));
          }, 12000);
        });

        // 創建 fetch Promise
        const fetchPromise = fetch(
          `${HYREAD_BASE_URL}/api/hyread/preview`
        ).then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP ${res.status}: ${res.statusText}`);
          }
          return res.json();
        });

        // 使用 Promise.race 來實現 timeout
        const data = await Promise.race([fetchPromise, timeoutPromise]);

        setPreviewBooks(data);
      } catch (err) {
        console.error('Fetch failed:', err);
        setError(err);
        setPreviewBooks([]); // 清空資料
      } finally {
        setLoading(false);
      }
    };

    fetchHyread();
  }, []);

  return { previewBooks, error, loading };
};

export default useHyreadPreview;
